import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// خط Cairo من Google Fonts
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800;900&display=swap';
document.head.appendChild(link);

// Reset CSS
const style = document.createElement('style');
style.textContent = `* { margin: 0; padding: 0; box-sizing: border-box; } body { background: #F9FAFB; -webkit-tap-highlight-color: transparent; } input, textarea, select, button { font-family: 'Cairo', sans-serif; } ::-webkit-scrollbar { display: none; }`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
